import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()

export class MagasinService {

    list:string[] = ['Aubonne', 'Genève', 'VTT'];
    current:string = 'Aubonne';

    public onChangeMagasin:BehaviorSubject<any> = new BehaviorSubject(this.current);

    constructor() {

    }

    change(){
        this.onChangeMagasin.next(this.current);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/services/magasin.service.ts